<template>
  <div class="activityRules-container">
    <van-nav-bar title="活动规则">
      <template #left>
        <img
          class="leftImg"
          @click="$router.push('/activeWheel')"
          src="@/assets/jiantou@2x.png"
          alt=""
        />
      </template>
    </van-nav-bar>
    <div class="content-box">
      <div class="box">
        <img class="rightImg" src="~@/assets/zpqietu/xlh@2x.png" alt="" />
        <div class="actitext">
          <p v-for="(item, index) in prizeExplains" :key="index">
            {{ item }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActionConfig } from "@/api/new";

export default {
  name: "activityRules",
  components: {},
  props: {},
  data() {
    return {
      prizeExplains: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.getActionConfigs();
  },
  mounted() {},
  methods: {
    async getActionConfigs() {
      const { data: res } = await getActionConfig();
      this.prizeExplains = res.data.prizeExplains;
    },
  },
};
</script>

<style scoped  lang="less">
.content-box {
  display: flex;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 92px);
  background: url("../../assets/zpqietu/hdgztck@2x.png") no-repeat;
  background-size: cover;
  overflow: auto;
}
.leftImg {
  width: 27px;
  height: 44px;
}
.box {
  width: 616px;
  height: 604px;
  position: relative;
  margin: 30px auto;
  background: url("../../assets/zpqietu/cxdtcw@2x.png") no-repeat;
  background-size: cover;
}
.rightImg {
  position: absolute;
  right: 0;
  bottom: 15px;
  width: 147px;
  z-index: 99;
}
.actitext {
  position: absolute;
  top: 136px;
  height: 310px;
  overflow-x: hidden;
  overflow-y: scroll;
}
p {
  font-weight: bold;
  font-size: 26px;
  margin: 0 50px;
  color: #d31b1c;
  margin-top: 10px;
}
span {
  font-weight: 500;
  color: #87260b;
}
.inner-container::-webkit-scrollbar {
  display: none;
}
</style>